import React, { useEffect } from "react";
import { Form, Input, Space, FormInstance } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import FormDrawer from "../common/formdrawer";
import CancelButton from "../common/cancelbutton";
import FormButton from "../common/formbutton";
import { BusinessUnit } from "../../services/businessunitservice";

interface BusinessUnitDrawerProps {
  open: boolean;
  editing: BusinessUnit | null;
  form: FormInstance;
  onClose: () => void;
  onSave: () => void;
  saving?: boolean;
}

const BusinessUnitDrawer: React.FC<BusinessUnitDrawerProps> = ({
  open,
  editing,
  form,
  onClose,
  onSave,
  saving,
}) => {
  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const footer = (
    <div style={{ textAlign: "right" }}>
      <Space>
        <CancelButton onClick={handleClose} />
        <FormButton
          title={editing ? "Save" : "Create"}
          icon={editing ? <EditOutlined /> : <PlusOutlined />}
          loading={saving}
          onClick={() => {
            form
              .validateFields()
              .then(() => onSave())
              .catch(() => {});
          }}
        />
      </Space>
    </div>
  );

  return (
    <FormDrawer
      title={editing ? "Edit Business Unit" : "Add Business Unit"}
      open={open}
      onClose={handleClose}
      onSave={() => {}}
      form={form}
      footer={footer}
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: "Please enter a name" }]}
      >
        <Input placeholder="e.g. Estonia" />
      </Form.Item>
      <Form.Item
        name="code"
        label="Code"
        rules={[{ required: true, message: "Please enter a code" }]}
      >
        <Input placeholder="e.g. EE" />
      </Form.Item>
    </FormDrawer>
  );
};

export default BusinessUnitDrawer;
